/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Shared chrome used by leaf feature NgModules. Expand carefully —
 * prefer feature-local declarations over growing this module.
 */
import {CommonModule} from '@angular/common';

import {EnvBannerComponent} from './directives/banners/env-banner-component';
import {GhosteryBannerComponent} from './directives/banners/ghostery-banner-component';
import {BrowserUpdateBannerComponent} from './directives/banners/browser-update-banner-component';
import {PromiseSpinnerComponent} from './directives/html/promise-spinner.component';
import {InfoIconComponent} from './directives/html/info-component';
import {FormSubmissionMessage} from './directives/form-controls/form-submission-message';
import {ValidationWarningsComponent} from './directives/error/validation-warnings-component';
import {SimpleValidationMessagesComponent} from './directives/error/simple-validation-messages-component';
import {SimpleErrorMessagesComponent} from './directives/error/simple-error-messages-component';
import {DeleteInfoComponent} from './directives/delete-info-component';
import {AdminFieldValidationComponent} from './directives/admin-form-field-validation.component';
import {AdminFieldGroupDirective} from './directives/admin-field-group.directive';
import {OgTranslatePipe} from './filters/og-translate.pipe';
import {SafeHtmlPipe} from './filters/safe-html.pipe';
import {LocaleDatePipe} from './filters/locale-date.pipe';
import {LocaleNumberPipe} from './filters/locale-number.pipe';
import {LocalePercentPipe} from './filters/locale-percent.pipe';
import {PercentagePipe} from './filters/percentage.pipe';
import {StatPipe} from './filters/stat.pipe';
import {DisplayStatPipe} from './filters/display-stat.pipe';
import {AdnNumberPipe} from './filters/adn-number.pipe';
import {IsoCurrencyPipe, StringToCurrencyPipe} from './filters/iso-currency.pipe';
import {ClampPopoverViewportDirective} from './directives/clamp-popover-viewport.directive';
import {CopyToClipboardButtonComponent} from './directives/copy-to-clipboard-button.component';
import {LabelRepeaterComponent} from './directives/html/label-repeater.component';

export const APP_SHARED = [
  CommonModule,
  EnvBannerComponent,
  GhosteryBannerComponent,
  BrowserUpdateBannerComponent,
  PromiseSpinnerComponent,
  InfoIconComponent,
  FormSubmissionMessage,
  ValidationWarningsComponent,
  SimpleValidationMessagesComponent,
  SimpleErrorMessagesComponent,
  DeleteInfoComponent,
  AdminFieldValidationComponent,
  AdminFieldGroupDirective,
  OgTranslatePipe,
  SafeHtmlPipe,
  LocaleDatePipe,
  LocaleNumberPipe,
  LocalePercentPipe,
  PercentagePipe,
  StatPipe,
  DisplayStatPipe,
  AdnNumberPipe,
  IsoCurrencyPipe,
  StringToCurrencyPipe,
  ClampPopoverViewportDirective,
  CopyToClipboardButtonComponent,
  LabelRepeaterComponent
];
